import React, { useContext, useEffect } from "react";
import { ContentSection, ButtonProps, ButtonRenderProps, createListTableColumns, ListTable } from "sprint-common-web";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { ciRoutes, getBucketArchiveHref } from "../../ContentIngestionRoutes";
import { BucketArchiveListingContext } from "../context/BucketArchiveListingContext";
import { AddBucketArchiveButton } from "../create/AddBucketArchiveButton";
import { ImportArchiveBucketButton } from "../import/ImportArchiveBucketButton";
import { BucketArchiveItem } from "./BucketArchiveItem";
import { useBucketArchiveListing } from "./useBucketArchiveListing";
import { useBucketArchiveListingFilters } from "./useBucketArchiveListingFilters";

export const BucketArchiveListing: React.VFC = () => {
    const { filters, setSort, setPage, setPageSize } = useBucketArchiveListingFilters();
    const { items, totalItems, saveData } = useBucketArchiveListing();

    const { bucketArchiveItems, isLoading } = useContext(BucketArchiveListingContext);

    useEffect(() => {
        saveData(bucketArchiveItems, {
            page: filters.page,
            pageSize: filters.pageSize,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder
        });
    }, [
        filters.page,
        filters.pageSize,
        filters.sortBy,
        filters.sortOrder,
        bucketArchiveItems,
        bucketArchiveItems.length
    ]);

    const columns = createListTableColumns<BucketArchiveItem>([
        {
            type: "link",
            key: "uniqueId",
            name: "Unique ID",
            minWidth: 160,
            maxWidth: 160,
            isSortable: true,
            getHref: (item) => getBucketArchiveHref(item.bucketName)
        },
        {
            type: "basic",
            key: "bucketName",
            name: "Name",
            minWidth: 160,
            maxWidth: 160
        }
    ]);

    const addBucketArchiveButton: ButtonRenderProps<ButtonProps> = {
        render: AddBucketArchiveButton
    };

    const importBucketArchiveButton: ButtonRenderProps<ButtonProps> = {
        render: ImportArchiveBucketButton
    };

    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={ciRoutes} />
            </PageHeader>
            <ContentSection header="Buckets Archive" buttons={[addBucketArchiveButton, importBucketArchiveButton]}>
                <ListTable
                    columns={columns}
                    items={items}
                    pagination={{
                        page: filters.page,
                        pageSize: filters.pageSize,
                        totalItems,
                        onPageChange: setPage,
                        onPageSizeChange: setPageSize
                    }}
                    sort={{ by: filters.sortBy, order: filters.sortOrder }}
                    onSortChange={setSort}
                    isLoading={isLoading}
                />
            </ContentSection>
        </>
    );
};
